// extracted by mini-css-extract-plugin
export default {"mainCard":"QuoteCarousal_mainCard__hqea9"};